import { defu } from 'defu'
import routerOptions from '#build/router.options.mjs'
const sensitiveMatcher = /* @__PURE__ */ (() => { const $0={}; return (m,p)=>{let r=[];if(p.charCodeAt(p.length-1)===47)p=p.slice(0,-1);if(p==="/_nuxt"){r.push({data:$0});}else if(p.charCodeAt(p.length-1)===47){if(p==="/_nuxt/"){r.push({data:$0});}}return r.reverse();}})()
const foldedMatcher = sensitiveMatcher
export default (path) => routerOptions.sensitive
  ? defu({}, ...sensitiveMatcher('', path).map(r => r.data).reverse())
  : defu({}, ...foldedMatcher('', typeof path === 'string' ? path.toLowerCase() : path).map(r => r.data).reverse())